// The room's error, worded in the player's language. The server's own
// `message` is English-only, so it is never shown: the code picks the text.
import type { LobbyInfo } from '@bn-games/room-client';
import { t } from '../i18n/I18n.js';

/** `fallback` covers the codes with nothing specific to say on a lobby screen. */
export function roomErrorText(info: LobbyInfo, fallback: string): string {
  switch (info.errorCode) {
    case 'ROOM_NOT_FOUND':
      return t('online.errors.roomNotFound');
    case 'ROOM_FULL':
      return t('online.errors.roomFull');
    case 'ROOM_EXPIRED':
      return t('online.errors.roomExpired');
    case null:
      // No code: the socket dropped before the room answered.
      return info.errorMessage === null ? fallback : t('online.errors.connectionLost');
    default:
      return fallback;
  }
}
